exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customer-form .PhoneInputInput,\n#location-form .PhoneInputInput,\n#user-form .PhoneInputInput,\n#company-form .PhoneInputInput {\n    border: 0px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/customer/customerForm.styles.css
// module id = 5304
// module chunks = 0